import React from 'react';
import { Calendar, MapPin, Music, Clock, Users, Award, Phone, Mail, Globe } from 'lucide-react';
import './nimeahidi.css';

const Nimeahidi = () => {
  const activities = [
    'Piano', 'Guitar', 'Bass', 'Drums', 'Saxophone', 'Trumpets', 'Tuba', 'Flute', 'Clarinet', 'Viola', 'Cello', 'Ballet', 'Drumline & Marching'
  ];

  const highlights = [
    'All instruments provided - no need to bring your own!',
    'Students of all levels welcome - Beginner to Advanced',
    'Perfect for every aspiring musician',
    'Want to something big (even if they\'re shy)',
    '5+ years'
  ];

  // WhatsApp handler
  const handleWhatsAppEnroll = () => {
    const message = encodeURIComponent("Hi! I'm interested in enrolling my child in the Nimeahidi 2-Week Music & Performance Camp (4th-16th August 2025). Please send me more information about registration.");
    const whatsappUrl = `https://wa.me/254732259259?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="festival-container">
      {/* Title with animation */}
      <h1 className="festival-title">
        <span className="festival-highlight">Nimeahidi</span>
      </h1>
      
      <div className="subtitle">
        2-Week Music & Performance Camp
      </div>

      {/* Main content grid */}
      <div className="content-grid">
        {/* Left side - Event details */}
        <div className="left-content">
          <div className="festival-card info-card">
            <h3 className="card-title">Event Details</h3>
            <div className="info-item">
              <Calendar className="info-icon" />
              <span>4th-16th August 2025</span>
            </div>
            <div className="info-item">
              <Clock className="info-icon" />
              <span>Monday - Friday: 9:30AM - 3:30PM</span>
            </div>
            <div className="info-item">
              <MapPin className="info-icon" />
              <span>Gem Cambridge Grounds</span>
            </div>
            <div className="info-item">
              <Music className="info-icon" />
              <span>Live Concert: August 16th, 2PM - 4PM</span>
            </div>
          </div>

          <div className="festival-card pricing-card">
            <h3 className="card-title">Investment</h3>
            <div className="pricing-options">
              <div className="price-option">
                <span className="price">KES 1,500</span>
                <span className="price-label">PER DAY</span>
              </div>
              <div className="price-option">
                <span className="price">KES 16,500</span>
                <span className="price-label">TOTAL</span>
              </div>
            </div>
            <p className="pricing-includes">
              Includes: Professional instruction, instruments, lunch, snacks & a holistic creative experience.
            </p>
          </div>

          <div className="contact-buttons">
            <button type="button" className="festival-button primary">
              <Phone className="button-icon" />
              0717 000 059
            </button>
            <button type="button" className="festival-button secondary">
              <Phone className="button-icon" />
              0732 259 259
            </button>
          </div>
        </div>

        {/* Right side - Program details */}
        <div className="right-content">
          <div className="festival-card description-card">
            <h3 className="card-title">Joint School Symphony Concert</h3>
            <p className="festival-description">
              <span className="festival-highlight-text">Unleash Their Talent!</span> An exclusive camp for students from our partner schools, promoting talent development, collaboration and musical excellence.
            </p>
            <div className="finale-highlight">
              <Award className="finale-icon" />
              <span className="finale-text">11 days, 1 big finale!</span>
            </div>
          </div>

          <div className="festival-card activities-card">
            <h3 className="card-title">Activities Include:</h3>
            <div className="activities-grid">
              {activities.map((activity, index) => (
                <div key={index} className="activity-item">
                  <Music className="activity-icon" />
                  <span>{activity}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="festival-card highlights-card">
            <h3 className="card-title">Program Highlights</h3>
            <ul className="highlights-list">
              {highlights.map((highlight, index) => (
                <li key={index} className="highlight-item">
                  <span className="highlight-bullet">•</span>
                  {highlight}
                </li>
              ))}
            </ul>
          </div>

          <div className="festival-card benefits-card">
            <h3 className="card-title">What You'll Gain</h3>
            <div className="benefits-list">
              <div className="benefit-item">
                <Users className="benefit-icon" />
                <span>Break through music barriers and improve your performance skills</span>
              </div>
              <div className="benefit-item">
                <Music className="benefit-icon" />
                <span>Join a real orchestra</span>
              </div>
              <div className="benefit-item">
                <Users className="benefit-icon" />
                <span>Make friends</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact footer */}
      <div className="contact-footer">
        <div className="contact-info">
          <Mail className="contact-icon" />
          <span>elimika@sarafrika.com</span>
        </div>
      </div>

      {/* Call to action */}
      <div className="cta-section">
        <h2 className="cta-title">ENROLL NOW!</h2>
        <p className="cta-subtitle">Develop intensive skills. Unleash your child's potential, build confidence, and show off on stage.</p>
        <div className="cta-buttons">
          <button 
            type="button" 
            className="cta-button primary"
            onClick={handleWhatsAppEnroll}
          >
            <Users className="button-icon" />
            Enroll in Camp
          </button>
        </div>
      </div>
    </div>
  );
};

export default Nimeahidi;

// import React from 'react';
// import './nimeahidi.css';
// import { Calendar, MapPin, Music } from 'lucide-react';

// /* eslint-disable arrow-body-style */

// const Nimeahidi = () => {
//   return (
//     <div className="festival-container">
//       {/* Title with animation */}
//       <h1 className="festival-title">
//         <span className="festival-highlight">Nimeahidi</span> Festival 2025
//       </h1>

//       {/* Left side content */}
//       <div className="left-content">
//         <div className="festival-card info-card">
//           <p className="info-item">
//             <Calendar className="info-icon" />
//             <span>Event Date: 16th August 2025</span>
//           </p>
//           <p className="info-item">
//             <MapPin className="info-icon" />
//             <span>Location: Gem Cambridge Grounds</span>
//           </p>
//         </div>

//         <button type="button" className="festival-button">
//           Get Tickets / Learn More
//         </button>
//       </div>

//       {/* Right side content */}
//       <div className="right-content">
//         <div className="festival-card description-card">
//           <p className="festival-description">
//             Join us for an unforgettable experience at <span className="festival-highlight-text">Nimeahidi</span>, where music, art, food, and culture come together in a vibrant celebration!
//             Whether you are here for the electrifying performances, immersive art installations, or delicious culinary delights, there is something for everyone.
//           </p>
//         </div>

//         <div className="festival-card feature-card">
//           <Music className="feature-icon" />
//           <span className="feature-text">A Symphony of 1000 Musicians</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Nimeahidi;
